import { AnyAction } from 'redux';

import { getTags, Tags } from '@ttstr/api';
import { getTagsReceived } from '@ttstr/reducers/tags';

import { ThunkActionCreator } from '.';

export const TAGS_REQUESTED = 'TAGS.TAGS_REQUESTED';
export const TAGS_ALREADY_RECEIVED = 'TAGS.TAGS_ALREADY_RECEIVED';
export const TAGS_RECEIVED = 'TAGS.TAGS_RECEIVED';
export const TAGS_FAILED = 'TAGS.TAGS_FAILED';

export interface TagsReceivedAction extends AnyAction {
  payload: {
    tags: Tags;
  };
}

let requestTagsAbortController: AbortController;
export const requestTags: ThunkActionCreator = () => async (dispatch, getState) => {
  if (requestTagsAbortController) requestTagsAbortController.abort();

  requestTagsAbortController = new AbortController();
  dispatch({
    type: TAGS_REQUESTED,
  });

  try {
    // TODO This "cache" needs to be invalidated eventually
    if (getTagsReceived(getState())) {
      dispatch({
        type: TAGS_ALREADY_RECEIVED,
      });
      return;
    }

    const tags = await getTags({ signal: requestTagsAbortController.signal });
    dispatch<TagsReceivedAction>({
      type: TAGS_RECEIVED,
      payload: {
        tags,
      },
    });
  } catch (error) {
    dispatch({
      type: TAGS_FAILED,
      payload: {
        error,
      },
    });
  }
};
